import Container from "../../components/Container";
import Asside from "../../components/Asside";
import Header from "../../components/Header";
import ContainerPage from "../../components/ContainerPages";

import { Outlet } from "react-router-dom";

const Home = () => {
  return (
    <Container>
      <Asside />
      <>
        <div className="w-full md:col-span-8 lg:col-span-10 xl:col-span-7">
          <Header />
          <ContainerPage>
            <Outlet />
          </ContainerPage>
        </div>
      </>
    </Container>
  );
};

export default Home;
